"use client";

import { useDateTime } from "../../hooks/useDateTime";
import { menuBarItems } from "../../data/projects";
import apple_logo from "../../assets/imgs/apple_logo.svg";
import battery from "../../assets/imgs/battery_Menu_Icons.svg";
import wifi from "../../assets/imgs/wifi_MenuBarIcons.svg";
import options from "../../assets/imgs/option_Menu_Icons.svg";

export default function MenuBar({ closeMac }) {
  const { formatTime, formatDate } = useDateTime();

  return (
    <div className="absolute top-0 left-0 right-0 h-8 z-50">
      <div
        className="absolute inset-0 flex items-center justify-between px-4"
        style={{
          backdropFilter: "blur(68px)",
          WebkitBackdropFilter: "blur(68px)",
          backgroundColor: "rgba(255, 255, 255, 0.5)",
        }}
      >
        {/* Left side - Nav items */}
        <div className="flex items-center gap-8">
          {/* Apple logo */}
          <div 
          className="flex items-center gap-3">
            <div onClick={()=>closeMac(false)} className="cursor-pointer">

          <img src={apple_logo} alt="Apple Logo" className="w-5 h-5 mb-1" />
            </div>
         
          <a href="/" className="text-[14.5px] leading-10" style={{
                fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif',
                fontWeight: 600,
              }}>Badusha's Portfolio</a>
          </div>
          {menuBarItems.left.map((item, i) => (
            <a
              key={i}
              href={item.href}
              target={item.href.startsWith("http") || item.href.startsWith("mailto") ? "_blank" : undefined}
              rel={item.href.startsWith("http") ? "noopener noreferrer" : undefined}
              className="text-[13.5px] leading-none text-black/85 hover:text-black transition-colors"
              style={{
                fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif',
                fontWeight: item.bold ? 700 : 500,
              }}
            >
              {item.label}
            </a>
          ))}
        </div>

        {/* Right side - System icons and clock */}
        <div className="flex items-center gap-2">
          {/* WiFi icon */}
          <img src={wifi} alt="WiFi" />
          {/* Battery icon */}
          <img src={battery} alt="Battery" />
          {/* Search icon */}
          <svg width="13" height="13" viewBox="0 0 13 13" fill="black" className="opacity-80">
            <path d="M5.5 0a5.5 5.5 0 0 1 4.38 8.82l3.03 3.03a.75.75 0 0 1-1.06 1.06L8.82 9.88A5.5 5.5 0 1 1 5.5 0Zm0 1.5a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" />
          </svg>
          {/* Control center icon */}
          <img src={options} alt="Control Center" />
          {/* Siri */}
          <div className="w-[18px] h-[18px] rounded-full overflow-hidden">
            <img
              src="https://framerusercontent.com/images/dPmBV7RVqajiEK5Z6fWoKM30s5c.png"
              alt="Siri"
              className="w-full h-full object-cover"
            />
          </div>
          {/* Date and Time */}
          <div
            className="flex items-center gap-3 text-[13.5px] leading-none text-[#252525]"
            style={{
              fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif',
              fontWeight: 500,
              fontVariantNumeric: "tabular-nums",
            }}
          >
            <span>{formatDate()}</span>
            <span>{formatTime()}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
